import React from "react";
import { DashboardContext } from "./DashboardLayout";
import { ProfileTab } from "./tabs/ProfileTab";

export const ProfilePage: React.FC = () => {
  // Get data from context
  const dashboardData = React.useContext(DashboardContext);
  if (!dashboardData) {
    throw new Error("ProfilePage must be used within DashboardLayout");
  }

  const { user } = dashboardData;

  return <ProfileTab user={user} />;
};
